import { Button } from './button';

export interface TrialExpiredScreenProps {
  /** Route to the upgrade flow (e.g. Contact Sales). */
  onUpgrade: () => void;
  /** Optional sign-out handler. */
  onSignOut?: () => void;
}

/**
 * Full-screen "trial ended" lockout. Rendered in place of the entire app when a
 * trial has expired, so the user can only contact sales to upgrade — no other
 * page is reachable. Presentational only; wire `onUpgrade` to the upgrade flow.
 */
export function TrialExpiredScreen({ onUpgrade, onSignOut }: TrialExpiredScreenProps) {
  return (
    <div className="fixed inset-0 z-[60] flex flex-col items-center justify-center gap-6 bg-background p-6 text-center">
      <div className="max-w-md space-y-3">
        <h1 className="text-2xl font-semibold text-foreground">Your trial has ended</h1>
        <p className="text-muted-foreground">
          Contact sales to upgrade your account and restore access to Commander.
        </p>
      </div>
      <Button onClick={onUpgrade} size="lg">
        Contact sales to upgrade
      </Button>
      {onSignOut && (
        <button
          type="button"
          onClick={onSignOut}
          className="text-sm text-muted-foreground underline underline-offset-2 hover:text-foreground"
        >
          Sign out
        </button>
      )}
    </div>
  );
}
